import { data } from '../../svg/Entity/data';
import { makeIcon } from '../makeIcon';

export const Entity = makeIcon(data, 'entity', 'Entity');

export default Entity;
